"use client"

import { createContext, useContext } from "react"

const SuffixContext = createContext<string | undefined>(undefined)

export const SuffixProvider: React.FC<{
  suffix?: string
  children: React.ReactNode
}> = ({ suffix, children }) => {
  return <SuffixContext.Provider value={suffix}>{children}</SuffixContext.Provider>
}

export const useSuffix = () => {
  const context = useContext(SuffixContext)
  return context
}
